// extracted by mini-css-extract-plugin
export var activeFilterButton = "_r1-c";
export var backButton = "_r1-4";
export var backIcon = "_r1-5";
export var chevronShortcut = "_r1-6";
export var container = "_r1-1";
export var editor = "_r1-8";
export var editorWrapper = "_r1-7";
export var prefix = "_r1-2";
export var searchIcon = "_r1-3";
export var suffix = "_r1-9";
export var suffixContent = "_r1-a";
export var suffixText = "_r1-b";
export var wrapper = "_r1-0";